import { useLocation, Link } from "react-router-dom";
import ResetPasswordForm from "../../components/AuthActions/ResetPasswordForm";
import VerifyEmailAction from "../../components/AuthActions/VerifyEmailAction";
import ConfirmEmailChangeAction from "../../components/AuthActions/ConfirmEmailChangeAction";
import AuthActionHeader from "../../components/AuthActions/AuthActionHeader";

// Single handler for all Firebase auth-action emails. Because the Firebase
// console won't let us customize the action URL, the server generates the action
// link, extracts the code, and re-points it here. We dispatch on `mode`:
//   resetPassword / verifyEmail -> Firebase oobCode
//   changeEmail                 -> our own one-time token (verify-before-change)
const AuthAction = () => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const mode = params.get("mode");
  const oobCode = params.get("oobCode");
  const token = params.get("token");

  switch (mode) {
    case "resetPassword":
      return <ResetPasswordForm oobCode={oobCode} />;
    case "verifyEmail":
      return <VerifyEmailAction oobCode={oobCode} />;
    case "changeEmail":
      return <ConfirmEmailChangeAction token={token} />;
    default:
      return (
        <div className="flex flex-col py-12 px-4">
          <AuthActionHeader />
          <h2 className="text-center text-2xl font-bold tracking-tight text-gray-900">
            Invalid link
          </h2>
          <p className="text-center text-sm text-gray-900 mt-2">
            This link is invalid or unsupported.
          </p>
          <div className="px-4 py-4 w-full flex justify-center fixed bottom-0 bg-gray-50">
            <Link to="/login" className="text-sm text-indigo-600 font-medium">
              Back to login
            </Link>
          </div>
        </div>
      );
  }
};

export default AuthAction;
